import { render } from "./LanguageMulti.vue?vue&type=template&id=45f01c2e"
import script from "./LanguageMulti.vue?vue&type=script&lang=js"
export * from "./LanguageMulti.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__